export var SampleType;
(function (SampleType) {
    SampleType["BLOOD"] = "BLOOD";
    SampleType["URINE"] = "URINE";
    SampleType["BLOOD_AND_URINE"] = "BLOOD_AND_URINE";
    SampleType["SALIVA"] = "SALIVA";
    SampleType["STOOL"] = "STOOL";
    SampleType["SWAB"] = "SWAB";
})(SampleType || (SampleType = {}));
